import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import { Typography } from 'seagull';
import styles from './PromptBubble.module.scss';
export const PromptBubble = (param)=>{
    let { children, className, testId } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        className: cn(styles.bubble, className),
        testId: testId,
        children: children
    });
};
